import React, { useMemo } from "react";
import { View, StyleSheet } from "react-native";
import NtText from "../../components/NtText";
import { useTheme } from "../../context/ThemeContext";

/**
 * Editorial section — fixed-width label on the left (with optional caption),
 * stacked fields on the right. Used on Company / Payment to break a step into
 * grouped chunks (Company info / Admin user / Card details / Billing address).
 */
function NtOnboardingEditorialSection({ label, caption, first, children }) {
  const { theme } = useTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);
  return (
    <View style={[styles.section, first && styles.sectionFirst]}>
      <View style={styles.labelCol}>
        <NtText style={styles.label}>{label}</NtText>
        {caption ? (
          <NtText style={styles.caption}>{caption}</NtText>
        ) : null}
      </View>
      <View style={styles.fieldsCol}>{children}</View>
    </View>
  );
}

const makeStyles = (t) =>
  StyleSheet.create({
    section: {
      flexDirection: "row",
      gap: 40,
      paddingVertical: 28,
      borderTopWidth: 1,
      borderTopColor: t.borderSoft,
    },
    sectionFirst: {
      borderTopWidth: 0,
      paddingTop: 0,
    },
    labelCol: { width: 200 },
    label: {
      fontSize: 14,
      fontWeight: "700",
      color: t.text,
      letterSpacing: -0.1,
    },
    caption: {
      marginTop: 4,
      fontSize: 12,
      color: t.textDim,
      lineHeight: 18,
    },
    fieldsCol: {
      flex: 1,
      flexDirection: "column",
      gap: 6,
    },
  });

export default NtOnboardingEditorialSection;
